import React from 'react';
import moment from 'moment';

import { MCButton } from 'src/components/basic';
import { popupModel } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';
import LANG_CONST from 'src/helpers/lang/const';

import { permissions } from 'src/helpers';

import AddAnalyse from './create';
import AnalyseItem from './item';
import AlertManager from '../alert';
import MCVirtuoso from 'components/complex/MCVirtuoso';

const { ACTIONS } = permissions;

class AnalyseList extends BaseComponent {
  componentDidMount() {
    this.props.model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    this.props.model.unsubscribe(this.subscription);
  }

  onDelete = (item) => () => {
    let { model } = this.props;
    AlertManager.popup(AlertManager.TYPES.WARN, {
      close: false,
      title: LANG_CONST.notice.delete,
      cancelButton: {
        label: LANG_CONST.buttons.no,
        action: (actions) => actions.hide()
      },
      actionButton: {
        label: LANG_CONST.buttons.yes,
        action: (actions) => {
          actions.setLoading(true);
          model.delete(item, () => {
            actions.hide();
            actions.setLoading(false);
          });
        }
      }
    });
  };

  onEdit = (item) => () => {
    let { model } = this.props;

    popupModel.setActivePopup(ACTIONS.ANALYSES_ADD_BUTTON.key, {
      active: true,
      component: AddAnalyse,
      props: { model, item }
    });
  };

  render() {
    let { model, onPrivacySettings, showAi = true } = this.props;
    const showAddAnalyze = true;
    return (
      <>
        {showAddAnalyze && (
          <div className={'mc-flex mc-wrap mc-mlr30 mc-mt20'}>
            <div className={'mc-grow'} />
            <MCButton
              medium
              light
              primary
              radius
              onClick={() =>
                popupModel.setActivePopup(ACTIONS.ANALYSES_ADD_BUTTON.key, {
                  active: true,
                  component: AddAnalyse,
                  props: { model }
                })
              }
              label={LANG_CONST.buttons.add_analyses}
            />
          </div>
        )}
        <div className={'mc-analyse mc-mt20'}>
          <MCVirtuoso
            model={model}
            itemContent={(index, item) => {
              let timeMessage = moment(item.date).format('ddd,DD MMM');
              if (index === 0) {
                this.lastDate = timeMessage;
              } else if (this.lastDate === timeMessage) {
                timeMessage = null;
              } else {
                this.lastDate = timeMessage;
              }
              let showDelete = model.delete && item.from === model.state.user?.id;
              let showEdit = model.edit && item.from === model.state.user?.id;
              if (model.canModify) {
                showDelete = showEdit = model.canModify(item);
              }
              return (
                <AnalyseItem
                  key={item.id}
                  auth={model.state.user}
                  showAi={showAi}
                  timeMessage={timeMessage}
                  item={item}
                  index={index}
                  privacySettingsData={item.data?.privacySettings}
                  onPrivacySettings={onPrivacySettings}
                  onDelete={showDelete && this.onDelete(item)}
                  onEdit={showEdit && this.onEdit(item)}
                />
              );
            }}
          />
        </div>
      </>
    );
  }
}

export default AnalyseList;
